import PoseurCompliance from "./PoseurCompliance";
import React, { useState } from "react";
import { X, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { FieldInput, FileCell } from "./fields";

export default function RowEditor({ family, row, families, onClose, onSaved }) {
  const [vals, setVals] = useState(() => ({ ...(row?.values || {}) }));
  const [cur, setCur] = useState(row);
  const [busy, setBusy] = useState(false);
  const cols = family.columns;
  const save = async () => {
    setBusy(true);
    const values = Object.fromEntries(cols.filter((c) => c.type !== "file").map((c) => [c.id, vals[c.id] ?? null]));
    try {
      const r = cur ? await api.put(`/families/${family.id}/rows/${cur.id}`, { values }) : await api.post(`/families/${family.id}/rows`, { values });
      toast.success("Ligne enregistrée");
      onSaved();
      if (!cur && cols.some((c) => c.type === "file")) setCur(r.data); else onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm("Supprimer cette ligne ?")) return;
    try { await api.delete(`/families/${family.id}/rows/${cur.id}`); toast.success("Ligne supprimée"); onSaved(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Suppression impossible"); }
  };
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-norea-border" data-testid="family-row-editor">
        <div className="flex items-center justify-between px-5 py-4 border-b border-norea-border">
          <h3 className="font-heading text-lg font-medium">{cur ? `Modifier — ${cur.values[cols[0].id] || ""}` : `Nouvelle ligne — ${family.name}`}</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-norea-surfaceHover" data-testid="row-editor-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          {cols.map((c) => (
            <label key={c.id} className={`text-xs text-norea-textMuted space-y-1 ${c.type === "file" || c.multiple ? "md:col-span-2" : ""}`}>
              <span>{c.label}</span>
              {c.type === "file"
                ? <div><FileCell family={family} row={cur} col={c} onDone={onSaved} /></div>
                : <FieldInput col={c} value={vals[c.id]} onChange={(v) => setVals({ ...vals, [c.id]: v })} families={families} testid={`row-input-${c.id}`} />}
            </label>
          ))}
          {cur && family.id === "poseurs" && <PoseurCompliance annuaireId={cur.id} />}
        </div>
        <div className="px-5 py-3 border-t border-norea-border flex items-center gap-2">
          {cur && <button onClick={remove} className="text-xs text-norea-textMuted hover:text-status-erreurText inline-flex items-center gap-1" data-testid="row-delete"><Trash2 className="w-3.5 h-3.5" /> Supprimer</button>}
          <button onClick={onClose} className="btn-secondary text-sm ml-auto">Fermer</button>
          <button onClick={save} disabled={busy} className="btn-primary text-sm" data-testid="row-save">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Enregistrer</button>
        </div>
      </div>
    </div>
  );
}
